/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingModeEnum } from './BillingModeEnum';
import {
    BillingModeEnumFromJSON,
    BillingModeEnumFromJSONTyped,
    BillingModeEnumToJSON,
    BillingModeEnumToJSONTyped,
} from './BillingModeEnum';
import type { DefaultCurrencyEnum } from './DefaultCurrencyEnum';
import {
    DefaultCurrencyEnumFromJSON,
    DefaultCurrencyEnumFromJSONTyped,
    DefaultCurrencyEnumToJSON,
    DefaultCurrencyEnumToJSONTyped,
} from './DefaultCurrencyEnum';
import type { DefaultTimeFormatEnum } from './DefaultTimeFormatEnum';
import {
    DefaultTimeFormatEnumFromJSON,
    DefaultTimeFormatEnumFromJSONTyped,
    DefaultTimeFormatEnumToJSON,
    DefaultTimeFormatEnumToJSONTyped,
} from './DefaultTimeFormatEnum';
import type { Membership } from './Membership';
import {
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
    MembershipToJSONTyped,
} from './Membership';

/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {number}
     * @memberof Team
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    name: string;
    /**
     * Always returns an empty array — the slim TeamSerializer intentionally omits the
     * full member list for payload size. Use the `useOrgMembers(orgId)` hook to fetch
     * members lazily when needed.
     * @type {Array<Membership>}
     * @memberof Team
     */
    readonly members: Array<Membership>;
    /**
     * Return permission group names for the request user in this org.
     * 
     * Degrades gracefully to empty list on any error to avoid crashing
     * the org list endpoint.
     * @type {Array<string>}
     * @memberof Team
     */
    readonly permissionGroups: Array<string>;
    /**
     * Return resolved permissions for the request user in this org.
     *
     * Returns list of {entity_type_name, event_type_name} dicts.
     * Degrades gracefully to empty list on any error.
     * @type {Array<{ [key: string]: any; }>}
     * @memberof Team
     */
    readonly permissions: Array<{ [key: string]: any; }>;
    /**
     *
     * @type {boolean}
     * @memberof Team
     */
    readonly hasActiveSubscription: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Team
     */
    readonly isPayingCustomer: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Team
     */
    readonly footerGateEnforced: boolean;
    /**
     *
     * @type {string}
     * @memberof Team
     */
    readonly billingMode?: BillingModeEnum;
    /**
     *
     * @type {boolean}
     * @memberof Team
     */
    readonly pendingInviteCheckout?: boolean;
    /**
     *
     * @type {DefaultCurrencyEnum}
     * @memberof Team
     */
    defaultCurrency?: DefaultCurrencyEnum;
    /**
     *
     * @type {DefaultTimeFormatEnum}
     * @memberof Team
     */
    defaultTimeFormat?: DefaultTimeFormatEnum;
    /**
     * Derived default phone region (ISO 3166-1 alpha-2), or null when the org has no derived region.
     * @type {string}
     * @memberof Team
     */
    readonly defaultPhoneRegion?: string | null;
    /**
     * Entity ID for org-level visibility associations
     * @type {string}
     * @memberof Team
     */
    readonly entityId: string | null;
    /**
     * Slack channel URL for design partner communication
     * @type {string}
     * @memberof Team
     */
    readonly slackChannelUrl: string;
    /**
     *
     * @type {number}
     * @memberof Team
     */
    readonly purchasedSeats: number | null;
    /**
     * The requesting user's full membership record for this org, or null when not a member.
     * @type {Membership}
     * @memberof Team
     */
    readonly currentUserMembership: Membership | null;
    /**
     * Active (non-deactivated) member count for this org.
     * @type {number}
     * @memberof Team
     */
    readonly memberCount: number;
    /**
     * Seat features granted to the request user in this org.
     * Hand-added bridge pending a full client regen.
     * Optional: absent on stale payloads — treat as all features present (see useFeatureAccess).
     * @type {Array<string>}
     * @memberof Team
     */
    readonly features?: string[];
}



/**
 * Check if a given object implements the Team interface.
 */
export function instanceOfTeam(value: object): value is Team {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('permissionGroups' in value) || value['permissionGroups'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('hasActiveSubscription' in value) || value['hasActiveSubscription'] === undefined) return false;
    if (!('isPayingCustomer' in value) || value['isPayingCustomer'] === undefined) return false;
    if (!('footerGateEnforced' in value) || value['footerGateEnforced'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('slackChannelUrl' in value) || value['slackChannelUrl'] === undefined) return false;
    if (!('purchasedSeats' in value) || value['purchasedSeats'] === undefined) return false;
    if (!('currentUserMembership' in value)) return false;
    if (!('memberCount' in value) || value['memberCount'] === undefined) return false;
    return true;
}

export function TeamFromJSON(json: any): Team {
    return TeamFromJSONTyped(json, false);
}

export function TeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): Team {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'members': ((json['members'] as Array<any>).map(MembershipFromJSON)),
        'permissionGroups': json['permission_groups'],
        'permissions': json['permissions'] == null ? [] : json['permissions'],
        'hasActiveSubscription': json['has_active_subscription'],
        'isPayingCustomer': json['is_paying_customer'],
        'footerGateEnforced': json['footer_gate_enforced'],
        'billingMode': json['billing_mode'] == null ? undefined : BillingModeEnumFromJSON(json['billing_mode']),
        'pendingInviteCheckout': json['pending_invite_checkout'] == null ? undefined : json['pending_invite_checkout'],
        // NOTE: manual divergence from generator output. pendingInviteCheckout is a read-only field
        // not included in generated output; preserve this line on regeneration (make build-api-client).
        'defaultCurrency': json['default_currency'] == null ? undefined : DefaultCurrencyEnumFromJSON(json['default_currency']),
        'defaultTimeFormat': json['default_time_format'] == null ? undefined : DefaultTimeFormatEnumFromJSON(json['default_time_format']),
        'defaultPhoneRegion': json['default_phone_region'] == null ? null : json['default_phone_region'],
        'entityId': json['entity_id'],
        'slackChannelUrl': json['slack_channel_url'],
        'purchasedSeats': json['purchased_seats'] == null ? null : json['purchased_seats'],
        // NOTE: manual divergence from generator output. The generator would emit
        // 'memberCount': json['member_count'] (no fallback). We use ?? 0 so that
        // existing MSW JSON fixtures (which omit member_count) keep type-safety
        // without forcing a ~20-file fixture update. Re-running make build-api-client
        // will overwrite this — preserve the comment on regeneration.
        'currentUserMembership': json['current_user_membership'] == null ? null : MembershipFromJSON(json['current_user_membership']),
        'memberCount': json['member_count'] == null ? 0 : json['member_count'],
        // NOTE: manual divergence from generator output. features is a hand-bridged field;
        // absent on stale payloads — treat as all features present (see useFeatureAccess).
        'features': json['features'] == null ? undefined : json['features'],
    };
}

  export function TeamToJSON(json: any): Team {
      return TeamToJSONTyped(json, false);
  }

  export function TeamToJSONTyped(value?: Omit<Team, 'id'|'members'|'permissionGroups'|'permissions'|'hasActiveSubscription'|'isPayingCustomer'|'footerGateEnforced'|'billingMode'|'pendingInviteCheckout'|'defaultPhoneRegion'|'entityId'|'slackChannelUrl'|'purchasedSeats'|'currentUserMembership'|'memberCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
        'default_currency': DefaultCurrencyEnumToJSON(value['defaultCurrency']),
        'default_time_format': DefaultTimeFormatEnumToJSON(value['defaultTimeFormat']),
    };
}

